// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * Models for general operations
 */
import type * as Schemas from '../schemas.js';






/**
 * Response for getOpenApiSpec
 * 
 * @public
 */
export type GetOpenApiSpecResponse = Record<string, any>;